{
  "allergens": {
    "CELERY": "Celery",
    "clearAll": "Clear all",
    "CRUSTACEANS": "Crustaceans",
    "EGGS": "Eggs",
    "FISH": "Fish",
    "GLUTEN": "Gluten",
    "LUPIN": "Lupin",
    "MILK": "Lactose",
    "MOLLUSCS": "Molluscs",
    "MUSTARD": "Mustard",
    "none": "None",
    "PEANUTS": "Peanuts",
    "SESAME": "Sesame",
    "SOYBEANS": "Soybeans",
    "SULPHITES": "Sulphites",
    "title": "Allergens",
    "TREE_NUTS": "Tree nuts"
  },
  "auth": {
    "alreadySignedIn": "You're already signed in as {{currentName}} (<currentMailto>{{currentEmail}}</currentMailto>). Sign out to create a new account with email <newMailto>{{newEmail}}</newMailto>.",
    "alreadySignedInTitle": "You're already signed in",
    "backToHome": "Back to Home",
    "cannotJoinAccountExists": "An account already exists for your email address <inviteeMailto>{{inviteeEmail}}</inviteeMailto>. Please ask {{inviterName}} (<inviterMailto>{{inviterEmail}}</inviterMailto>) to invite you using a different email address.",
    "cannotJoinTeamTitle": "Can't join the team",
    "completeSignup": "Complete your account",
    "completeSignupSubtitle": "Tell us your name and you're in.",
    "continueButton": "Continue",
    "invitedBy": "{{name}} has invited you to join their team on Calculabel.",
    "invitedByEmail": "{{name}} ({{email}}) has invited you to join their team.",
    "linkInvalidSubtitle": "This sign-in link has expired or has already been used. Request a new one.",
    "linkInvalidTitle": "Link no longer works",
    "namePlaceholder": "Your full name",
    "requestNewLink": "Request a New Link",
    "signingIn": "Signing you in…"
  },
  "billing": {
    "adminOnly": "Only team admins can manage billing.",
    "cancelScheduledBare": "Your team's paid plan will end at the period end. Reactivate from the billing portal to keep editing.",
    "cancelScheduledBody": "Your team's paid plan ends on {{date}}. Reactivate from the billing portal to keep editing.",
    "cancelScheduledTitle": "Plan cancellation scheduled",
    "checkoutSuccessBody": "Your payment was successful. You can now use Calculabel without restrictions.",
    "checkoutSuccessTitle": "Subscription activated",
    "currentPeriodEnd": "Next payment",
    "freeAccessUntil": "Free access until",
    "lockedAdmin": "Please choose a subscription plan to keep editing recipes, ingredients, and producers.",
    "lockedMember": "Ask your team admin to add a payment method to keep editing.",
    "lockedTitle": "Free access ended",
    "manageBilling": "Manage Subscription & Invoices",
    "openSubscription": "Open Subscription",
    "pastDueAdmin": "Your last payment was unsuccessful. Update your payment method to continue this subscription.",
    "pastDueMember": "Your last payment for the service was unsuccessful. Ask your admin to update the payment method.",
    "pastDueTitle": "Payment problem",
    "sectionManage": "Subscription management",
    "sectionStatus": "Current status",
    "sectionSubscribe": "Subscribe",
    "statusActive": "Active",
    "statusCanceled": "Canceled",
    "statusIncomplete": "Incomplete",
    "statusIncompleteExpired": "Incomplete (expired)",
    "statusNone": "No subscription",
    "statusPastDue": "Past due",
    "statusPaused": "Paused",
    "statusTrialing": "Trialing",
    "statusUnpaid": "Unpaid",
    "stripeNote": "Calculabel uses Stripe to securely process payments and manage subscriptions. Your card details are stored and handled by Stripe — they never touch our servers. Payment history and invoices are available in the Stripe portal.",
    "subscribe": "Subscribe",
    "subscriptionEndedOn": "Canceled on",
    "subscriptionStatus": "Subscription status",
    "subscriptionWillEndOn": "Active until",
    "tabTitle": "Subscription",
    "trialDaysLeft_one": "{{count}} day left of free access — ends {{date}}.",
    "trialDaysLeft_other": "{{count}} days left of free access — ends {{date}}.",
    "trialEndingSoonTitle": "Free access ending soon",
    "trialEndingTitle": "Free access ending"
  },
  "caseToggle": {
    "lowerCase": "lower case",
    "sentenceCase": "Sentence case",
    "titleCase": "Title Case",
    "upperCase": "UPPER CASE"
  },
  "common": {
    "back": "Back",
    "cancel": "Cancel",
    "create": "Create",
    "createdBy": "Created by",
    "editName": "Edit {{name}}",
    "email": "Email",
    "legal": "Legal notice",
    "name": "Full name",
    "privacy": "Privacy Policy",
    "save": "Save",
    "terms": "Terms of Use"
  },
  "error": {
    "application-error": {
      "description": "Something went wrong. Please try again or reload the page.",
      "title": "An error occurred"
    },
    "auth": {
      "email-link-expired": "This sign-in link has expired. Request a new one.",
      "email-link-not-found": "This sign-in link is invalid.",
      "email-link-used": "This sign-in link has already been used.",
      "not-authenticated": "You must be logged in to perform this action.",
      "not-authorized": "You do not have permission to perform this action.",
      "signup-name-required": "Please enter your name to finish signing up."
    },
    "ingredient": {
      "deleted": "This ingredient has been deleted and cannot be modified.",
      "not-found": "Ingredient not found.",
      "price-invalid": "Invalid price: the quantity must be positive, and the price and VAT rate cannot be negative.",
      "price-unit-not-weight": "Prices can only be entered in weight units."
    },
    "network-error": {
      "description": "Unable to reach the server. Please check your connection.",
      "title": "Network error"
    },
    "producer": {
      "deleted": "This producer has been deleted and cannot be modified.",
      "not-found": "Producer not found."
    },
    "recipe": {
      "circular-dependency": "Adding this recipe would create a circular reference — the selected recipe already depends on this one.",
      "circular-self-reference": "A recipe cannot contain itself as an ingredient.",
      "deleted": "This recipe has been deleted and cannot be modified.",
      "not-found": "Recipe not found.",
      "not-published": "This recipe has no published version to duplicate."
    },
    "subscription": {
      "access-locked": "Your team's free access has ended. Add a payment method to keep editing.",
      "no-customer": "This team does not have a billing customer yet.",
      "stripe-unavailable": "Billing is temporarily unavailable. Please try again shortly."
    },
    "team": {
      "cannot-join-account-exists": "An account already exists for your email address.",
      "cannot-remove-last-admin": "The team must keep at least one admin.",
      "invitation-already-exists": "An invitation for this email is already pending. Cancel it first if you want to send a new one.",
      "invitation-email-undeliverable": "We couldn't reach this email address — check the spelling and try again.",
      "invitation-not-found": "This invitation link is invalid.",
      "member-not-found": "Team member not found.",
      "not-found": "Team not found.",
      "settings-invalid": "Invalid currency or country code."
    },
    "unknown": "An unexpected error occurred."
  },
  "g": {
    "actions": "Actions",
    "reload": "Reload",
    "saving": "Saving…",
    "savingError": "Save failed — click to retry",
    "searching": "Searching…"
  },
  "ingredients": {
    "actions": "Actions",
    "allergens": "Allergens",
    "allergensHelp": "Additional allergens that aren't part of the ingredients but you want to declare",
    "allergensPlaceholder": "Select allergens…",
    "archivedVersionBannerAction": "View current ingredient",
    "archivedVersionBannerText": "This is an old version of this ingredient.",
    "brand": "Brand",
    "comparePhotos": {
      "drawerTitle": "Label photos",
      "open": "Compare with Label Photos"
    },
    "continueEditing": "Continue Editing",
    "createChoice": {
      "fromGeneric": "Use data from food database",
      "fromGenericDesc": "Search the food database for nutritional data",
      "fromLabel": "From product label",
      "fromLabelDesc": "Take a photo of the label and we'll create the ingredient from it",
      "manual": "Create manually",
      "manualDesc": "Enter all ingredient data yourself",
      "newFromLabel": "New ingredient",
      "uploadHint": "Upload, paste, or take a photo of the product label"
    },
    "createdAt": "Created",
    "createIngredient": "Create Ingredient",
    "delete": "Delete",
    "deleteConfirm": "Are you sure you want to delete this ingredient? This action cannot be undone.",
    "deletedBanner": "This ingredient has been deleted.",
    "deletedDone": "Ingredient deleted",
    "deleteTitle": "Delete ingredient",
    "description": "Description",
    "discardDraft": "Discard Draft",
    "discardDraftConfirm": "Are you sure you want to discard this draft? All unsaved changes will be lost.",
    "discardDraftTitle": "Discard draft",
    "draftBannerText": "This ingredient has an unpublished draft.",
    "edit": "Edit",
    "labelIngredients": {
      "add": "Add Ingredient",
      "addAfter": "Add another",
      "addChild": "Add sub-ingredient",
      "allergensPrefix": "Allergens:",
      "delete": "Delete",
      "deleteConfirm": "Are you sure you want to delete this ingredient and all its sub-ingredients?",
      "deleteTitle": "Delete ingredient",
      "emailPrefix": "email: ",
      "ingredientsPrefix": "Ingredients:",
      "nameColumn": "Ingredients",
      "namePlaceholder": "Ingredient name…",
      "noIngredients": "No label ingredients yet",
      "phonePrefix": "tel. ",
      "producerPrefix": "Producer:",
      "recognize": "Recognize the Label",
      "recognizeConfirm": "Are you sure? The name, description, label ingredients and energy values will be overwritten by the label recognition.",
      "recognizeConfirmTitle": "Recognize the label",
      "websitePrefix": "web: "
    },
    "name": "Name",
    "nameForLabel": "Name for label",
    "nameForLabelHelp": "Override name used on the product label. Leave empty to use the ingredient name.",
    "namePlaceholder": "Enter ingredient name…",
    "newIngredient": "New Ingredient",
    "noIngredients": "No ingredients found",
    "notFound": "Ingredient not found",
    "nutrition": {
      "alcohol": "Alcohol",
      "carbohydrate": "Carbohydrate",
      "energy": "Energy",
      "energyTooltip": "Automatically calculated from fat, carbohydrate, protein and fibre",
      "fat": "Fat",
      "fibre": "Fibre",
      "importAction": "Import",
      "importButton": "Import from Database",
      "importDone": "Nutrition data imported",
      "importedFrom": "Imported from: {{name}}",
      "importTitle": "Import nutrition data",
      "perHundredGrams": "Per 100 g",
      "perHundredGramsShort": "100 g",
      "perReference": "Per {{quantity}} {{unit}}",
      "protein": "Protein",
      "salt": "Salt",
      "saturatedFat": "of which saturates",
      "searchGenericIngredient": "Search food database...",
      "searchNoResults": "No ingredients found for \"{{query}}\"",
      "searchResultsCount_one": "Found {{count}} result",
      "searchResultsCount_other": "Found {{count}} results",
      "sugars": "of which sugars",
      "sync": "Sync",
      "syncDone": "Nutrition values synced",
      "unlink": "Unlink",
      "unlinkDone": "Source unlinked",
      "valuesPerLabel": "Nutrition values per"
    },
    "originalName": "Original name",
    "parentOutdated": "Needs update",
    "photos": {
      "empty": "No photos yet",
      "tooLarge": "File is too large (max 5 MB)",
      "upload": "Upload from computer",
      "uploadFailed": "Photo upload failed"
    },
    "price": {
      "changeButton": "Change Price",
      "dialogTitle": "Ingredient price",
      "empty": "No price set",
      "inlineWithoutVat": "excl. VAT",
      "inlineWithVat": "incl. VAT",
      "noVat": "No VAT",
      "perKgWithoutVat": "Per kg (excl. VAT)",
      "perKgWithVat": "Per kg (incl. VAT)",
      "price": "Price",
      "priceRequired": "Please enter a price",
      "priceSummary": "{{price}} ({{vat}}) for {{quantity}}",
      "quantity": "Quantity",
      "quantityRequired": "Please enter a quantity",
      "removeButton": "Remove Price",
      "removeDone": "Price removed",
      "saveDone": "Price saved",
      "setButton": "Set Price",
      "vatPresetLabel": "VAT {{rate}}%",
      "vatRate": "VAT rate",
      "withoutVat": "Excl. VAT",
      "withVat": "Incl. VAT"
    },
    "restore": "Restore",
    "restoreConfirm": "Restore this ingredient? It will become editable again.",
    "restoredDone": "Ingredient restored",
    "restoreTitle": "Restore ingredient",
    "save": "Save",
    "searchPlaceholder": "Search ingredients…",
    "source": "Source",
    "sourceData": "Source data",
    "sourceId": "Source ID",
    "sources": {
      "CNF": "Canadian Nutrient File (CNF)",
      "COFID": "McCance and Widdowson's composition of foods integrated dataset (CoFID)"
    },
    "tabGeneral": "General",
    "tabLabel": "Label",
    "tabLabelIngredients_one": "Label Ingredients ({{count}})",
    "tabLabelIngredients_other": "Label Ingredients ({{count}})",
    "tabNutrition": "Nutrition",
    "tabPhotos_one": "Photos ({{count}})",
    "tabPhotos_other": "Photos ({{count}})",
    "tabPrice": "Price",
    "tabUsedInRecipes_one": "Used in recipes ({{count}})",
    "tabUsedInRecipes_other": "Used in recipes ({{count}})",
    "title": "Ingredients",
    "updatedAt": "Updated",
    "usedInRecipesEmpty": "This ingredient is not used in any recipes",
    "validation": {
      "nameRequired": "Please enter a name"
    }
  },
  "landing": {
    "comingSoon": "Coming soon",
    "features": {
      "mealPlanning": {
        "description": "Plan your weekly meals, generate shopping lists, and stay organized in the kitchen.",
        "title": "Meal Planning"
      },
      "nutrition": {
        "description": "Automatically calculate nutritional values for your recipes based on ingredients and portions.",
        "title": "Nutrition Calculator"
      },
      "purchases": {
        "description": "Track ingredient purchases, monitor prices, and plan your shopping efficiently.",
        "title": "Purchase Tracking"
      },
      "qrLabels": {
        "description": "Generate QR code labels linking to recipes, nutritional info, or custom content.",
        "title": "QR Code Labels"
      },
      "recipes": {
        "description": "Store, organize, and search all your recipes in one place. Never lose a favorite recipe again.",
        "title": "Recipe Management"
      },
      "wineLabels": {
        "description": "Design and print professional wine labels for your homemade wines and beverages.",
        "title": "Wine Labels"
      }
    },
    "featuresTitle": "Everything you need",
    "footer": "© 2026 Calculabel. All rights reserved.",
    "getStarted": "Get Started",
    "getStartedFree": "Get Started for Free",
    "heroSubtitle": "Manage recipes, calculate nutrition values, track ingredient purchases, create wine labels, and generate QR code labels — all in one place.",
    "heroTitle": "Your kitchen, organized",
    "navFeatures": "Features",
    "navPricing": "Pricing",
    "openApp": "Open App",
    "pricingSubtitle": "Every feature included. Pay monthly or save with annual billing. Start your 14-day free trial — no credit card required.",
    "pricingTitle": "Simple, transparent pricing",
    "signIn": "Sign In"
  },
  "layout": {
    "ingredients": "Ingredients",
    "myAccount": "My Account",
    "producers": "Producers",
    "recipes": "Recipes",
    "signOut": "Sign Out",
    "signOutConfirm": "Are you sure you want to sign out?",
    "signOutTitle": "Sign out"
  },
  "login": {
    "checkInboxSubtitle": "We sent a sign-in link to",
    "checkInboxTitle": "Check your inbox",
    "consentLine": "By clicking <strong>{{button}}</strong> you agree to our <termsLink>Terms of Use</termsLink> and <privacyLink>Privacy Policy</privacyLink>.",
    "invitationOnlyNote": "Calculabel is currently invitation-only. To create a new account you need an invitation link from an existing team — existing users can sign in below.",
    "sendLink": "Send Me a Sign-In Link",
    "subtitle": "Enter your email and we'll send you a link to sign in. No password needed.",
    "title": "Sign in to Calculabel",
    "useDifferentEmail": "Use a Different Email",
    "validation": {
      "emailInvalid": "Please enter a valid email",
      "emailRequired": "Please enter your email"
    }
  },
  "myAccount": {
    "emailHelp": "Email is locked to the address you signed up with. Contact support to change it.",
    "fullName": "Full name",
    "profileTab": "Profile",
    "profileUpdated": "Profile updated successfully",
    "saveChanges": "Save Changes",
    "teamTab": "Team",
    "title": "My Account",
    "validation": {
      "nameRequired": "Name is required"
    }
  },
  "nutrition": {
    "declaration": {
      "carbohydrate": "carbohydrate",
      "energy": "energy",
      "fat": "fat",
      "fibre": "fibre",
      "header": "Nutrition information per 100g:",
      "protein": "protein",
      "salt": "salt",
      "saturatedFat": "of which saturates",
      "sugars": "of which sugars"
    }
  },
  "offline": {
    "restored": "Connection restored",
    "title": "You are offline. Please check your internet connection."
  },
  "phone": {
    "delete": "Delete",
    "deleteAll": "Delete All Photos",
    "deleteAllConfirm": "Are you sure you want to delete all uploaded photos?",
    "deleteAllTitle": "Delete all photos",
    "deleteConfirm": "Are you sure you want to delete this photo?",
    "deleteTitle": "Delete photo",
    "hint": "These photos are available on the desktop app wherever you can upload photos.",
    "modalButton": "Take a Photo",
    "modalHint": "Scan this QR code with your phone to upload photos directly from your camera.",
    "modalTitle": "Upload from phone",
    "noPhotos": "Photos uploaded from your phone will appear here",
    "notLoggedIn": "Please scan the QR code again",
    "recentPhotos": "Recently uploaded photos",
    "select": "Use",
    "upload": "Take Photo",
    "uploadFailed": "Upload failed",
    "uploading": "Uploading"
  },
  "pricing": {
    "annual": {
      "description": "Best price per month, billed once a year.",
      "monthlyEquivalent": "{{amount}} / month billed annually",
      "name": "Annual"
    },
    "feature": {
      "labelGeneration": "EU-compliant nutrition labels",
      "support": "Email support",
      "teamMembers": "Unlimited team members",
      "unlimitedIngredients": "Unlimited ingredients",
      "unlimitedRecipes": "Unlimited recipes"
    },
    "intervalMonth": "/month",
    "intervalYear": "/year",
    "monthly": {
      "description": "Maximum flexibility, no long-term commitment.",
      "name": "Monthly"
    },
    "savingsBadge": "Save {{amount}}",
    "startTrial": "Start 14-Day Free Trial",
    "stripeNote": "Calculabel uses Stripe to securely process payments and manage subscriptions. Your card details are stored and handled by Stripe — they never touch our servers.",
    "taxBehavior": {
      "exclusive": "Price excludes VAT and other taxes.",
      "inclusive": "VAT included",
      "unspecified": ""
    }
  },
  "producers": {
    "actions": "Actions",
    "address": "Address",
    "companyName": "Company name",
    "createdAt": "Created",
    "createProducer": "Create Producer",
    "delete": "Delete",
    "deleteConfirm": "Are you sure you want to delete this producer?",
    "deletedBanner": "This producer has been deleted.",
    "deletedDone": "Producer deleted",
    "deleteTitle": "Delete producer",
    "edit": "Edit",
    "email": "Email",
    "namePlaceholder": "Enter company name",
    "newProducer": "New Producer",
    "noProducers": "No producers yet",
    "notFound": "Producer not found",
    "phone": "Phone",
    "restore": "Restore",
    "restoreConfirm": "Are you sure you want to restore this producer?",
    "restoredDone": "Producer restored",
    "restoreTitle": "Restore producer",
    "save": "Save Changes",
    "saved": "Producer details saved",
    "searchPlaceholder": "Search producers…",
    "tabGeneral": "General",
    "tabUsedInRecipes_one": "Recipes ({{count}})",
    "tabUsedInRecipes_other": "Recipes ({{count}})",
    "title": "Producers",
    "updatedAt": "Updated",
    "usedInRecipesEmpty": "No recipes use this producer",
    "validation": {
      "companyNameRequired": "Company name is required",
      "emailInvalid": "Please enter a valid email"
    },
    "website": "Website"
  },
  "recipes": {
    "actions": "Actions",
    "addIngredient": "Add Ingredient",
    "addIngredientDone": "Ingredient added",
    "addIngredientTitle": "Add ingredient",
    "allergens": "Allergens",
    "allergensHelp": "Additional allergens that aren't part of the ingredients but you want to declare",
    "allergensPlaceholder": "Select allergens…",
    "archivedVersionBannerAction": "View current recipe",
    "archivedVersionBannerText": "This is an old version of this recipe.",
    "continueEditing": "Continue Editing",
    "costBreakdown": {
      "per100g": "Per 100 g",
      "perKg": "Per 1 kg",
      "perPackage": "Per package",
      "perServing": "Per serving",
      "title": "Cost price",
      "tooltip": "Price details",
      "total": "Recipe price"
    },
    "createAndAdd": "Create and Add",
    "createAndReplace": "Create and Replace",
    "createdAt": "Created",
    "createRecipe": "Create recipe",
    "delete": "Delete",
    "deleteConfirm": "Are you sure you want to delete this recipe?",
    "deletedBanner": "This recipe has been deleted.",
    "deletedDone": "Recipe deleted",
    "deleteTitle": "Delete recipe",
    "description": "Description",
    "discardDraft": "Discard Draft",
    "discardDraftConfirm": "Are you sure you want to discard this draft? All unpublished changes will be lost.",
    "discardDraftTitle": "Discard draft",
    "draftBannerText": "This recipe has an unpublished draft.",
    "duplicate": "Duplicate",
    "duplicatedDone": "Recipe duplicated",
    "duplicateNameSuffix": "(copy)",
    "duplicateTitle": "Duplicate recipe",
    "edit": "Edit",
    "ingredientDeletedTooltip": "This ingredient was deleted after it was added to this recipe",
    "ingredientName": "Ingredient",
    "ingredientOutdated": "Outdated",
    "ingredientOutdatedTooltip": "This ingredient was updated after it was added to this recipe",
    "ingredientTypes": {
      "GenericIngredient": "Generic Ingredients",
      "IngredientRecipeIngredient": "Ingredient",
      "SubRecipeRecipeIngredient": "Sub-recipe"
    },
    "ingredientUpToDate": "Up to date",
    "label": {
      "export": "Export Label",
      "noIngredients": "No ingredients added yet",
      "uppercaseAllergens": "Mark allergens with capital letters"
    },
    "name": "Name",
    "nameForLabel": "Name for label",
    "nameForLabelHelp": "Override name used on the product label. Leave empty to use the recipe name.",
    "namePlaceholder": "Enter recipe name…",
    "netWeight": "Net weight per package",
    "newRecipe": "New Recipe",
    "noIngredients": "There are no ingredients in this recipe",
    "noRecipes": "No recipes found",
    "notFound": "Recipe not found",
    "nutrition": {
      "carbohydrate": "Carbohydrate",
      "energy": "Energy",
      "fat": "Fat",
      "fibre": "Fibre",
      "noData": "No nutrition data available. Add ingredients to calculate.",
      "perHundredGrams": "Per 100 g",
      "perPackage": "Per package ({{grams}} g)",
      "perServing": "Per serving ({{grams}} g)",
      "protein": "Protein",
      "salt": "Salt",
      "saturatedFat": "of which saturates",
      "saturatedFatShort": "saturates",
      "sugars": "of which sugars",
      "sugarsShort": "sugars"
    },
    "openSubRecipeIngredients": "To change the recipe's price, change the prices of its ingredients",
    "parentOutdated": "Needs update",
    "price": "Price",
    "producer": "Producer",
    "producerPlaceholder": "Select producer…",
    "quantity": "Quantity",
    "removeIngredient": "Remove",
    "removeIngredientConfirm": "Are you sure you want to remove this ingredient?",
    "removeIngredientDone": "Ingredient removed",
    "removeIngredientTitle": "Remove ingredient",
    "replaceIngredient": "Replace",
    "replaceIngredientDone": "Ingredient replaced",
    "replaceIngredientTitle": "Replace ingredient",
    "restore": "Restore",
    "restoreConfirm": "Restore this recipe? It will become editable again.",
    "restoredDone": "Recipe restored",
    "restoreTitle": "Restore recipe",
    "save": "Save",
    "searchIngredient": "Search ingredient…",
    "searchNoResults": "Nothing found for \"{{query}}\"",
    "searchPlaceholder": "Search recipes…",
    "servingSize": "Serving size",
    "servingsPerPackage": "Servings per package",
    "showPrices": "Prices",
    "showQuantityTooltip": "Show percentage on the label. Required when the ingredient is mentioned in the product name.",
    "sortByWeight": "Sort by Weight",
    "sortByWeightDone": "Ingredients sorted by weight",
    "storagePresets": {
      "ambient": "Store at room temperature.",
      "coolDry": "Store in a cool, dry place.",
      "coolDryDark": "Store in a cool, dry place, away from direct sunlight.",
      "frozen": "Keep frozen at -18 °C. Do not refreeze after thawing.",
      "refrigerate": "Keep refrigerated at 0–4 °C.",
      "refrigerateOpened": "After opening, keep refrigerated and consume within 3 days."
    },
    "storagePresetsLabel": "Templates",
    "storageRequirements": "Storage requirements",
    "tabGeneral": "General",
    "tabIngredients_one": "Ingredients ({{count}})",
    "tabIngredients_other": "Ingredients ({{count}})",
    "tabLabel": "Label",
    "tabNutrition": "Nutrition",
    "tabPhotos_one": "Photos ({{count}})",
    "tabPhotos_other": "Photos ({{count}})",
    "tabUsedAsSubRecipe_one": "Used as sub-recipe ({{count}})",
    "tabUsedAsSubRecipe_other": "Used as sub-recipe ({{count}})",
    "title": "Recipes",
    "total": "Total",
    "updatedAt": "Updated",
    "updateIngredientVersion": "Update to latest version",
    "updateIngredientVersionDone": "Ingredient updated to latest version",
    "usedAsSubRecipeEmpty": "This recipe is not used as a sub-recipe in any other recipes",
    "validation": {
      "nameRequired": "Name is required"
    },
    "weightAfterCooking": "Weight after cooking",
    "withoutVat": "Excl. VAT",
    "withVat": "Incl. VAT",
    "yield": "Yield"
  },
  "team": {
    "actionAdminOnly": "Only admins can manage team members",
    "actionCannotActOnSelf": "You cannot do this to yourself",
    "actionLastAdmin": "The team must keep at least one admin",
    "cancelInvitation": "Cancel Invitation",
    "cancelInvitationConfirm": "Cancel the invitation for {{email}}?",
    "copyInviteLink": "Copy invite link",
    "demoteToMember": "Demote to member",
    "demoteToMemberConfirm": "Demote {{name}} to a member?",
    "expiresAt": "Expires",
    "invited": "Invited {{email}}",
    "inviteLinkCopied": "Invite link copied to clipboard",
    "inviteMember": "Invite Member",
    "joinedAt": "Joined",
    "memberRemoved": "Removed {{name}}",
    "members": "Members",
    "noPendingInvitations": "No pending invitations.",
    "pendingInvitations": "Pending invitations",
    "promoteToAdmin": "Promote to admin",
    "promoteToAdminConfirm": "Promote {{name}} to admin?",
    "removeMember": "Remove Member",
    "removeMemberConfirm": "Remove {{name}} from the team? Their login will be disabled, but the recipes, ingredients and producers they created stay with the team — nothing is deleted.",
    "role": "Role",
    "roleCapabilitiesAdmin": "Admins can invite, remove and re-role team members. They also have full access to recipes, ingredients and producers.",
    "roleCapabilitiesMember": "Members have full access to recipes, ingredients and producers, but cannot manage team membership.",
    "roles": {
      "ADMIN": "Admin",
      "MEMBER": "Member"
    },
    "roleUpdated": "Role updated",
    "sendInvite": "Send Invite",
    "settings": {
      "country": "Country",
      "currency": "Currency",
      "saveDone": "Settings saved",
      "title": "Settings"
    },
    "validation": {
      "emailInvalid": "Please enter a valid email",
      "emailRequired": "Please enter an email address"
    }
  }
}
